import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import { IconButton, Menu, makeStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import MoreHoriz from "@material-ui/icons/MoreHoriz";

import {
  DropdownMenu,
  AdminDropdownMenu,
  PartnerDropdownMenu,
} from "./MenuItems";

const useStyles = makeStyles((theme) => ({
  iconButton: {
    background: theme.palette.background.default,
    width: "39px",
    height: "39px",
    borderRadius: "15px",
  },
  meunItem: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    borderRadius: theme.spacing(1.5),
    textDecoration: "none",
    color: `${theme.palette.text.primary} !important`,

    "&:hover, &.active": {
      backgroundColor: theme.palette.background.default,
    },
  },
}));

const StyledMenu = withStyles({
  paper: {
    borderRadius: "20px",
    marginTop: "10px",
    padding: "10px",
    width: "200px",
  },
  list: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
  },
})((props) => (
  <Menu
    elevation={2}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
));

function MenuDropdown({ isAdmin, isPartner }) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="delete"
        className={classes.iconButton}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreHoriz />
      </IconButton>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {isAdmin &&
          AdminDropdownMenu.map((item, index) => (
            <NavLink
              key={index}
              onClick={handleClose}
              activeclassname="active"
              className={classes.meunItem}
              to={item.url}
            >
              {item.title}
            </NavLink>
          ))}

        {(isAdmin || isPartner) &&
          PartnerDropdownMenu.map((item, index) => (
            <NavLink
              key={index}
              onClick={handleClose}
              activeclassname="active"
              className={classes.meunItem}
              to={item.url}
            >
              {item.title}
            </NavLink>
          ))}
        {DropdownMenu.map((item, index) => (
          <NavLink
            key={index}
            onClick={handleClose}
            activeclassname="active"
            className={classes.meunItem}
            to={item.url}
          >
            {item.title}
          </NavLink>
        ))}
      </StyledMenu>
    </div>
  );
}

export default MenuDropdown;
